var content = require("!!../../../node_modules/css-loader/dist/cjs.js!../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../node_modules/sass-loader/lib/loader.js??ref--1-2!../../../node_modules/vuetify-loader/lib/loader.js!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./FooterBar.vue?vue&type=style&index=0&id=42de2f78&lang=scss&scoped=true&");

if (typeof content === 'string') {
  content = [[module.id, content, '']];
}

var options = {}

options.insert = "head";
options.singleton = false;

var update = require("!../../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js")(content, options);

if (content.locals) {
  module.exports = content.locals;
}
